import { SxProps, Theme } from '@mui/material/styles';

// shared by the top-level nav entries so they can't drift apart again;
// no vertical margin, so each one stretches to the toolbar height
export const navButtonSx: SxProps<Theme> = {
	color: 'white',
	alignSelf: 'stretch',
	px: 2,
	borderRadius: 0,
};
